/* tslint:disable */
/* eslint-disable */
/**
 * profile-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const TodosSubmissionsStatus = {
    NotSubmitted: 'Not Submitted',
    AwaitingResponse: 'Awaiting Response',
    WaitingOnOthers: 'Waiting on Others',
    Completed: 'Completed',
    RequiresAChange: 'Requires a Change',
    SubmittedForReview: 'Submitted for Review'
} as const;

export type TodosSubmissionsStatus = typeof TodosSubmissionsStatus[keyof typeof TodosSubmissionsStatus];



